<template>
	<div class="homePage">
		
		<div class="head">			
			<div>
				<div class="left">LOGO</div>
				<div class="right">
					<div>
						<ul class="nav">
							<li><a href="">主机</a></li>
							<li><a href="">个人中心</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
						</ul>
					</div>
					<div class="sear">
						<text class='search'></text>
						<input type="text" v-model="inputVal" :class="[{ inpuActive: isActive }]"  @mouseover ='inpuMouSeover' @mouseleave="inputMouseLeave"  @change="subSeach"/>
					</div>
				</div>
			</div>

		</div>
		<!-- 头部结束 -->

		<!-- 产品列表 -->
	
		<ul class="chanpinList clearFix">
			<li v-for="item in list" @click="detail">
				<a href=""> <img src="../assets/chanpin.jpg" alt=""> </a>
				<div class="price">￥2000</div>
				<p>产品名称产品名称产品名称产品名称产品名称产品名称产品名称</p>
			</li>
			
		</ul>
		<!-- 产品列表结束 -->
		
		<!-- 分页 -->
		<div class="fenye">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="1000">
			</el-pagination>
		</div>
		<!-- 分页结束 -->
	</div>
</template>

<script>
	export default{
		name:'homePage',
		data(){
			return{
				isActive:false,
				inputVal:'',
				list:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,]
			}			
		},
		methods:{
			// 鼠标移入sear
			inpuMouSeover:function(){
				this.isActive = true
			},
			// 失去焦点
			shiqu:function(){
				if(this.inputVal ==''){
					this.isActive = false
				}
			},
			// 鼠标移出sear
			inputMouseLeave:function(){
			
			},
			// 提交搜索
			subSeach:function(e){
				console.log(e)
				// this.$router.push('/search')
			},
			//产品详情
			detail:function(){
				this.$router.push('/detail')
			}
			
		}
	}
</script>
<style>
	
	body{
	 background: #f3f3f3;
	}
 .el-pagination.is-background .el-pager li{
	 background-color: white;
 }
 .el-pagination{
	 text-align: right;
 }
</style>
<style scoped>
	.fenye{
		width: 1200px;
		margin:0px auto 30px;
	}
	
	.chanpinList{
		background: #FFFFFF;
		width: 1200px;
		margin: 120px auto 60px;
		padding: 10px 0px 20px 10px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-everly;
		text-align: left;
	}
	.chanpinList>li{
		float: left;
		list-style: none;
		padding: 10px;
		box-shadow: 0 0 0px #959595;
		text-align: center;
	}
	.chanpinList>li:hover{
		box-shadow: 0 0 5px #666666;
	}
	.chanpinList>li>a{
		display: inline-block;
		width: 192px;
		height: 192px;
		line-height: 192px;
		margin: 7px auto 0px;
		overflow: hidden;
		vertical-align: middle;
		text-align: center;
	}
	.chanpinList>li>a:hover{
		
	}
	.chanpinList>li>a ,.chanpinList>li img{
		width: auto;
		height: auto;
		max-height: 100%;
		max-width: 100%;
		vertical-align: middle;
	}
	.chanpinList>li p{
		width: 210px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
				margin-bottom: 10px;
	}
	.price{
		color: #ff0023;
		margin: 7px 0px;
		font-size: 18px;
		text-align: left;
	}
	.head{
		width: 100%;
		height: 80px;
		line-height: 80px;		
		font-size: 14px;
		font-weight: 600;
		position: fixed;
		top: 0px;
		left: 0px;
		background-color: white;
		z-index: 30;
		box-shadow: 1px 1px 5px #EEEEEE;
	}
	.head>div{
		width: 1200px;
		margin: auto;
		display: flex;
		box-sizing: border-box;
		flex-direction: row;
		justify-content: space-between;
	}
	.head .left{
		
		width: 150px;
		background-color: rgb(39,85,161);
		color: white;
	}
	.right{
			display: flex;
			align-items: center;
	}
	.right .nav{
		width: 600px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0px 20px 0px auto;
	}
	.right .nav li a{
		padding: 10px 0px;
	}
	
	.right .nav li:hover>a{
		border-bottom: 1px solid rgb(39,85,161);
	}
	.right .sear{
		margin: 0px 10px;
		width: 160px;
		text-align: left;
	}
	.right .sear>input{
		width: 40px;
		background-color:#4876FF;
		color: white;
		border: 0px;
		outline: inherit;
		height: 25px;
		line-height: 25px;
		border-radius: 20px;
		background-image: url(../assets/sear.png);
		background-size: 15px 15px;
		background-repeat: no-repeat;
		background-position: 10px 4px;
		cursor:pointer;
		transition: all 1s;
		padding-left: 30px;
	}
/*  */
	.right .sear>input.inpuActive{
		width: 160px;
	}
	
	
</style>



// WEBPACK FOOTER //
// src/components/search.vue